var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55 1L1 3.66667M18 3.66667L15.45 1M4.4 15.2222L2.7 17M14.6 15.2222L16.3 17M6.95 10.3333L8.65 12.1111L12.475 8.11111M9.5 17C11.3035 17 13.0331 16.2508 14.3083 14.9172C15.5836 13.5836 16.3 11.7749 16.3 9.88889C16.3 8.0029 15.5836 6.19417 14.3083 4.86057C13.0331 3.52698 11.3035 2.77778 9.5 2.77778C7.69653 2.77778 5.96692 3.52698 4.69167 4.86057C3.41643 6.19417 2.7 8.0029 2.7 9.88889C2.7 11.7749 3.41643 13.5836 4.69167 14.9172C5.96692 16.2508 7.69653 17 9.5 17Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBlack);
export default __webpack_public_path__ + "static/media/clockBlack.a6c2ea612986f39887627bdbb367b7ef.svg";
export { ForwardRef as ReactComponent };